'use client';

import React from 'react';
import { useGlobalClientContext } from '../common/GlobalClientContext';
import { workloadDescTitleClassName, workloadDescClassName } from './Styles';
import RedirectButton from './RedirectButton';
import { convertBoldTagsToStrong } from '@altus-ui/components_v2/utils/text';
import { convertNewLinesToBrs } from '@altus-ui/components_v2/utils/text';

export default function Compute() {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();

  const networkingDesc = t('public.site.pricing.workload.networking.desc', {});
  return (
    <>
      <div className="flex flex-col gap-3xl items-center">
        <span className={workloadDescTitleClassName}>
          {t('public.site.pricing.workload.networking.title', {})}
        </span>
        <div className="flex flex-col">
          <span className={workloadDescClassName}>
            {convertNewLinesToBrs(networkingDesc)}
          </span>
        </div>
      </div>

      <RedirectButton
        className="mt-3xl"
        label={t('public.site.contact.us', {})}
      />
      <div className="flex flex-col w-[860px] mt-9xl">
        <div className="flex flex-row w-full border-t border-gray-200 bg-gray-50 gap-0 h-[68px] items-center text-md font-semibold leading-xl text-primary">
          <div className="flex flex-1 px-3xl text-md font-regular leading-xl !w-[300px]">
            {t('public.site.pricing.workload.networking.title1', {})}
          </div>
          <div className="flex flex-1 px-3xl text-md text-cic-blue-500 leading-xl justify-start font-semibold">
            {t('public.site.pricing.free', {})}
          </div>
        </div>
        <div className="flex flex-row w-full border-t border-gray-200 bg-white gap-0 h-[68px] items-center text-md font-semibold leading-xl text-primary">
          <div className="flex flex-1 px-3xl text-md font-regular leading-xl !w-[300px]">
            {t('public.site.pricing.workload.networking.title2', {})}
          </div>
          <div className="flex flex-1 px-3xl text-md text-cic-blue-500 justify-start font-semibold">
            $0.059 / per GB
          </div>
        </div>
        <div className="flex flex-row w-full border-t border-gray-200 bg-gray-50 gap-0 h-[68px] items-center text-md font-semibold leading-xl text-primary">
          <div className="flex flex-1 px-3xl text-md font-regular leading-xl !w-[300px]">
            {t('public.site.pricing.workload.networking.title3', {})}
          </div>
          <div className="flex flex-1 px-3xl text-md text-cic-blue-500 justify-start font-semibold">
            $0.055 / per GB
          </div>
        </div>
        <div className="flex flex-row w-full border-y border-gray-200 bg-white gap-0 h-[68px] items-center text-md font-semibold leading-xl text-primary">
          <div className="flex flex-1 px-3xl text-md font-regular leading-xl !w-[300px]">
            {t('public.site.pricing.workload.networking.title4', {})}
          </div>
          <div className="flex flex-1 px-3xl text-md text-cic-blue-500 justify-start font-semibold">
            $0.049 / per GB
          </div>
        </div>
        <div className="flex flex-col mt-xl w-full items-start">
          <div className="flex flex-row text-xs font-regular leading-xs text-secondary">
            {convertBoldTagsToStrong(t('public.site.pricing.gb.desc', {}))}
          </div>

          <div className="flex flex-row text-xs font-regular leading-xs text-secondary">
            {convertBoldTagsToStrong(t('public.site.pricing.tb.desc', {}))}
          </div>
        </div>
      </div>
    </>
  );
}
